
export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/3d9fb15cb61a563e19166e6888c187d9.jpg"
          alt="Houston Health Insurance Experts"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
        <div className="mb-6">
          <span className="inline-block bg-teal-500/90 text-white px-4 py-2 rounded-full text-sm font-medium">
            #1 Rated in Houston
          </span>
        </div>
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Top Health Insurance<br />Agencies in Houston, TX
        </h1>
        <p className="text-xl md:text-2xl text-white/95 mb-8 max-w-3xl mx-auto leading-relaxed">
          Expert guidance for self-employed professionals and higher earners seeking affordable private health insurance solutions
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a href="#top-agencies" className="bg-teal-500 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer">
            View Top 10 Agencies
          </a>
          <a href="tel:2812062619" className="bg-white text-gray-900 px-8 py-4 rounded-lg text-base font-semibold hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer">
            Call (281) 206-2619
          </a>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20">
            <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-user-heart-line text-2xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold text-white mb-2">Self-Employed Specialists</h3>
            <p className="text-white/90 text-sm">Tailored solutions for entrepreneurs and freelancers</p>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20">
            <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-money-dollar-circle-line text-2xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold text-white mb-2">Cost Reduction Experts</h3>
            <p className="text-white/90 text-sm">Help higher earners save on premium costs</p>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20">
            <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-line text-2xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold text-white mb-2">Private Insurance Focus</h3>
            <p className="text-white/90 text-sm">Specialized in individual and family plans</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white"></i>
      </div>
    </section>
  );
}
